module.exports = __webpack_public_path__ + "631992d4d3959991fec313f7689be2a3.png";